module.exports = __webpack_public_path__ + "static/media/search.50c824c0.svg";